import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { DialogConfirm, DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";

// SERVICE
import { pCtContractCommitteeUpdate } from "../../../service/400/P414Service";
import { genCommitteeTypeList } from "../../../service/GEN/GenService";

export default function P414({ dialog, setDialog, onGetpCtContractInfo }) {
    const [errData, setErrData] = useState(null);
    const [formObject, setformObject] = useState({ committeeId: 0, userId: "", contractNo: "", committeeName: "", committeeEmployeeId: "", committeeTitle: "" });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    // DIALOG
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    // DropDown
    const [committeeTypeItem, setCommitteeTypeItem] = useState([]);

    useEffect(() => {
        if (dialog.dialog_414.open === true) {
            setformObject({ ...formObject, ...dialog.dialog_414.dataSet, userId: dialog.dialog_414.userId, contractNo: dialog.dialog_414.contractNo });
        }
    }, []);

    useEffect(() => {
        onGetCommitteeTypeList();
    }, [formObject]);

    const onGetCommitteeTypeList = () => {
        const req = {
            userId: setViewForm("userId"),
        };
        genCommitteeTypeList(req).then(
            (res) => {
                setCommitteeTypeItem(res);
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const setViewForm = (key) => {
        return formObject[key] === "" || formObject[key] === null ? "" : formObject[key];
    };

    const setValueForm = (key, val) => {
        setformObject({ ...formObject, [key]: val });
    };

    const validation = (object, act) => {
        if (act === "D") {
            return true;
        } else {
            if (object.committeeName === "" || object.committeeEmployeeId === "" || object.committeeTitleCode === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        }
    };
    const handlerCloseDialog = () => {
        setDialog({ ...dialog, dialog_414: { open: false, action: "", dataSet: null } });
    };
    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };
    const submitForm = (act) => {
        if (validation(formObject, act)) {
            const req = {
                actionCode: act,
                committeeEmployeeId: setViewForm("committeeEmployeeId"),
                committeeId: setViewForm("committeeId"),
                committeeName: setViewForm("committeeName"),
                committeeTitle: setViewForm("committeeTitleCode"),
                contractNo: setViewForm("contractNo"),
                userId: setViewForm("userId"),
            };
            pCtContractCommitteeUpdate(req).then(
                (res) => {
                    setLoading(false);
                    handlerSettingDialogConfirm(res[0].statusCode === "C" ? "" : "", res[0].statusText);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const onHide = () => {
        handlerCloseDialog();
        setformObject({});
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            submitForm("D");
            setDeleteDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const footerButtonSingle = (orNo) => {
        const con = () => {
            handlerCloseDialog();
            onGetpCtContractInfo();
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(dialog.dialog_414.action === "EDIT" ? "U" : "A")} className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-ban" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
                <Button label="ลบรายการ" icon="pi pi-trash" onClick={() => setDeleteDialog({ open: true })} className="p-button-danger p-button" disabled={dialog.dialog_414.action === "EDIT" ? false : true} />
            </div>
        );
    };

    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />
            <Dialog header="คณะกรรมการตรวจรับพัสดุ" visible={dialog.dialog_414.open} style={{ width: "55vw" }} footer={renderFooter()} onHide={() => onHide()} blockScroll={true} className="p-fluid" maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-6">
                        <label>
                            ตำแหน่งในโครงการ<span style={{ color: "red" }}>*</span>
                        </label>
                        <Dropdown
                            className={submitted && !formObject.committeeTitle ? "p-invalid" : ""}
                            placeholder="เลือก ตำแหน่งในโครงการ"
                            value={setViewForm("committeeTitleCode")}
                            optionLabel="committeePositionDesc"
                            optionValue="committeePositionCode"
                            onChange={(e) => {
                                setformObject({ ...formObject, committeeTitleCode: e.target.value });
                            }}
                            options={committeeTypeItem}
                        />
                        {submitted && !formObject.committeeTitle && validateInputText("committeeTitle", "ตำแหน่งในโครงการ")}
                    </div>
                    <div className="p-col-12">
                        <label>เลขที่สัญญา</label>
                        <InputText id="contractNo" value={formObject.contractNo} onChange={(e) => setValueForm("contractNo", e.target.value)} maxLength={200} disabled={true} />
                    </div>
                    <div className="p-col-6">
                        <label>
                            ชื่อ–นามสกุล<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText placeholder="ระบุ  ชื่อ–นามสกุล" className={submitted && !formObject.committeeName ? "p-invalid" : ""} value={formObject.committeeName} onChange={(e) => setValueForm("committeeName", e.target.value)} maxLength={100} />
                        {submitted && !formObject.committeeName && validateInputText("committeeName", "ชื่อ–นามสกุล")}
                    </div>
                    <div className="p-col-6">
                        <label>
                            รหัสพนักงาน<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText placeholder="ระบุ  รหัสพนักงาน" className={submitted && !formObject.committeeEmployeeId ? "p-invalid" : ""} value={formObject.committeeEmployeeId} onChange={(e) => setValueForm("committeeEmployeeId", e.target.value)} maxLength="500" />
                        {submitted && !formObject.committeeEmployeeId && validateInputText("committeeEmployeeId", "รหัสพนักงาน")}
                    </div>
                </div>
            </Dialog>
            <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="ยืนยันเพื่อลบรายการ หรือกดยกเลิกเพื่อยกเลิกการทำรายการ" />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
